import { render, staticRenderFns } from "./InfosetsTable.vue?vue&type=template&id=a72567aa&"
import script from "./InfosetsTable.vue?vue&type=script&lang=ts&"
export * from "./InfosetsTable.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports